import React, {useEffect} from 'react';
import {connect, useStore} from 'react-redux';
import {Switch, withRouter, useHistory, useLocation} from 'react-router-dom';
//import {makeStyles, ThemeProvider, unstable_createMuiStrictModeTheme as createMuiTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/core/styles';
import {createMuiTheme, makeStyles} from './styles/muiTheme';
import './App.css';
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import ProtectedRoute from "./components/ProtectedRoute";
import authLayout from "./components/layouts/auth";
import CustomizedSnackbars from "./containers/SnackBar";
import * as actions from './store/actions/index';
import Login from "./containers/Auth/Login";
import SetPassword from "./containers/Auth/SetPassword";
import ResetPassword from "./containers/Auth/ResetPassword";
import ForgotPassword from "./containers/Auth/ForgotPassword";
import AppRoute from "./components/AppRoute";
import mainLayout from "./components/layouts/main";
import Account from "./containers/Dashboard/Account";
import Settings from "./containers/Dashboard/Settings";
import Vehicle from "./containers/Dashboard/Vehicle/Vehicle";
import Index from "./containers/Dashboard/Index";
import AddVehicle from "./containers/Dashboard/Vehicle/AddVehicle";
import EditVehicle from "./containers/Dashboard/Vehicle/EditVehicle";
import Register from "./containers/Auth/Register";
import OfferDetail from './containers/Dashboard/Offers/OfferDetail';
import AppointmentDetails from "./containers/Dashboard/Appointments/AppointmentDetails";
import Promo from "./containers/Dashboard/Promo"

const useStyles = makeStyles();

function getParam(name) {
    // Do not use URLSearchParams(search).get('name') it's removing some chars from the value delo-online+l13@yandex.by converted to delo-online l13@yandex.by
    const value =window.location.search.match(new RegExp('[\?\&]' + name + '=([^\&]*)(\&?)', 'i'));
    return value ? value[1] : value;
}

function App(props) {

    const classes = useStyles();
    const store = useStore();
    //const state = store.getState();
    const history = useHistory();

    // store.subscribe(() => {
    //     console.log('on subscribe', store.getState());
    // })

    useEffect(() => {
        if (!store.getState().auth.isInited) {
            props.onInitApp();
        }
        props.onTryAutoSignup(store.getState(), props.location.hash, history)
    }, [props, history, store]); // state.auth.token

    useEffect(() => {
        const isAuth = props.isAuthenticated;
        if (!isAuth || !props.authToken) {
            return ;
        }
        props.onSetTokenTimer(props.authToken);
    }, [props.isAuthenticated, props.authToken])

    const theme =  React.useMemo(
        createMuiTheme(props),
        [props.darkMode],
    );

    return (

        <React.Fragment>

            <div className={classes.main}>

                <ThemeProvider theme={theme}>
                    <CssBaseline/>

                    <Switch>
                        <AppRoute path="/" component={Login} layout={authLayout} exact/>
                        <AppRoute path="/set-password" component={SetPassword} layout={authLayout} exact/>
                        <AppRoute path="/reset-password" component={ResetPassword} layout={authLayout}  componentProps={{email: getParam('email')}}  exact/>
                        <AppRoute path="/forgot-password" component={ForgotPassword} layout={authLayout} exact/>
                        <AppRoute path="/register" component={Register} layout={authLayout} exact/>
                        <ProtectedRoute exact path='/dashboard' component={Index}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/account' component={Account}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/settings' component={Settings}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/vehicle' component={Vehicle}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/vehicle/add' component={AddVehicle}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/vehicle/:id' component={EditVehicle}
                                        layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/offers/:id' component={OfferDetail} layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/appointments/:id' component={AppointmentDetails} layout={mainLayout}/>
                        <ProtectedRoute exact path='/dashboard/promo' component={Promo}
                                        layout={mainLayout}/>
                    </Switch>

                    <CustomizedSnackbars/>


                </ThemeProvider>
            </div>


        </React.Fragment>

    );
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        authToken: state.auth.token,
        darkMode: state.app.darkMode
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignup: (state, hash, history) => dispatch(actions.authCheckState(state, hash, history)),
        onInitApp: () => dispatch(actions.authInit()),
        onSetTokenTimer: (token) => dispatch(actions.authSetTokenTimer(token))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
